import type { FC, ReactNode } from 'react';
import { NavLink } from 'react-router';
import { AlertCircle } from 'lucide-react';

import { CompactText } from 'ui/CompactText';

import styles from './TutorBanners.module.scss';

type TutorNoticeProps = {
  title: string;
  text?: string;
  items?: string[];
  icon?: ReactNode;
  linkTo?: string;
  linkLabel?: string;
  tone?: 'docs' | 'note';
};

export const TutorNotice: FC<TutorNoticeProps> = ({
  title,
  text,
  items,
  icon,
  linkTo,
  linkLabel,
  tone = 'docs',
}) => (
  <div className={tone === 'note' ? styles.note : styles.docs} role='status'>
    {tone === 'docs' && icon ? icon : null}

    <div className={styles.copy}>
      <p className={styles.title}>
        {tone === 'note' ? (
          <span className={styles.noteIcon} aria-hidden='true'>
            <AlertCircle size={18} />
          </span>
        ) : null}
        {title}
      </p>
      {text ? <CompactText className={styles.text}>{text}</CompactText> : null}
      {items && items.length > 0 ? (
        <ul className={styles.list}>
          {items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : null}
      {linkTo && linkLabel ? (
        <NavLink to={linkTo} className={styles.link}>
          {linkLabel}
        </NavLink>
      ) : null}
    </div>
  </div>
);
